import { render, staticRenderFns } from "./Testings.vue?vue&type=template&id=1f1fddc5&scoped=true"
import script from "./Testings.vue?vue&type=script&lang=ts"
export * from "./Testings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1fddc5",
  null
  
)

export default component.exports